<template>
  <div>
    <div class="wrapper-x-40">
      <h1>{{$t('admin.views.barriers.list.h1')}}</h1>
    </div>
    <div class="tabs">
      <div class="wrapper-x-40">
        <button
          :class="{ active: view == 'list' }"
          class="focus:outline-none"
          @click="setView('list')"
        >
          {{$t('main.tab_list')}}
        </button>
        <button
          v-if="licensed"
          :class="{ active: view == 'type' }"
          class="focus:outline-none"
          @click="setView('type')"
        >
          {{$t('main.tab_types')}}
        </button>
      </div>
    </div>
    <div class="content">
      <div v-if="view === 'list'">
        <div>
          <div>
            <ActionPanel
              @setType="setType"
              @setSort="setSort"
              @removeDeletes="removeDeletes"
              @blockDeletes="blockDeletes"
              @unblockDeletes="unblockDeletes"
              @copyDeletes="copyDeletes"
              :selectedSort="selectedSort"
              :selectedType="selectedType"
              :addLinkParams="{
                    name: 'add_barrier',
                    query: $route.query
                  }"
            />

            <div
              class="barrier-list table-list-wrapper wrapper-x-40"
              v-if="barriers"
            >
              <table>
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        @change="changeCheck"
                      />
                    </th>
                    <th
                      class="image-name"
                      colspan="2"
                    >Список:</th>
                    <th class="type">{{$t('main.column_type')}}:</th>
                    <th class="status">{{$t('main.column_status')}}:</th>
                    <th class="article">{{$t('main.column_article')}}:</th>
                    <th class="min-sizes">{{$t('main.column_price_pog_m')}}:</th>
                    <th class="copy-link">{{$t('main.column_link')}}:</th>
                    <th class="id">ID:</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="barrier in barriers"
                    :key="barrier.barrier_id"
                  >
                    <td>
                      <input
                        type="checkbox"
                        ref="checkDeletes"
                        :value="barrier.barrier_id"
                        v-model="deletes"
                      />
                    </td>
                    <td class="image">
                      <router-link
                        class="image-preview"
                        :to="{
                          name: 'edit_barrier',
                          params: {
                            barrier_id: barrier.barrier_id,
                          },
                        }"
                      ><img
                          :src="barrier.image"
                          :alt="barrier.name"
                        /></router-link>
                    </td>
                    <td class="name">
                      <router-link :to="{
                          name: 'edit_barrier',
                          params: {
                            barrier_id: barrier.barrier_id,
                          },
                          query: $route.query
                        }">
                        {{ barrier.name }}
                      </router-link>
                    </td>
                    <td class="type">
                      {{ barrier.type && barrier.type.name }}
                    </td>
                    <td class="status">
                      <button
                        @click="$store.dispatch('barriers/block', { deletes: [barrier.barrier_id], status: 0 })"
                        class="text-green-500"
                        :title="$t('main.active')"
                        v-if="barrier.status"
                      ><i class="fas fa-check"></i></button>
                      <button
                        @click="$store.dispatch('barriers/block', { deletes: [barrier.barrier_id], status: 1 })"
                        class="text-red-500"
                        :title="$t('main.not_active')"
                        v-else
                      ><i class="fa fa-lock"></i></button>
                    </td>
                    <td class="article">
                      {{ barrier.article }}
                    </td>
                    <td class="install-price">
                      {{ $toCurrency(barrier.price_pog_metr) }}
                    </td>
                    <td class="copy_link">
                      <BaseButtonCopyLink
                        :title="$t('main.copy_direct_link')"
                        :elementId="barrier.barrier_id"
                        groupElement="barrier"
                      />
                    </td>
                    <td class="id">{{ barrier.barrier_id }}</td>
                  </tr>
                </tbody>
              </table>
              <PaginationBar
                :meta="meta"
                :page="page"
                :per-page="parseInt(per_page)"
                :per-pages="perPages"
                @set-page="setPage"
                @set-per-page="setPerPage"
              />
            </div>
          </div>
        </div>
      </div>

      <ListTypes v-if="view === 'type'" />
    </div>
  </div>
</template>

<script>
import ActionPanel from "../../../components/Admin/ActionPanel.vue";
import PaginationBar from "../../../components/Admin/PaginationBar.vue";
import ListTypes from "../../../components/Admin/Types/List";
export default {
  name: "List",
  components: { ListTypes, ActionPanel, PaginationBar },
  data() {
    return {
      view: "list",
      deletes: [],
      selectPerPage: this.$store.state.barriers.per_page,
    };
  },
  async created() {
    const view = localStorage.getItem("barriers_view");
    this.view = view ? view : "list";
    this.receiveQuery();
  },

  computed: {
    settings() {
      return this.$store.state.settings.settings;
    },
    barriers() {
      return this.$store.state.barriers.barriers;
    },
    meta() {
      return this.$store.state.barriers.meta;
    },
    page() {
      return this.$store.state.barriers.page;
    },
    perPages() {
      return this.$store.state.settings.perPages;
    },
    selectedType() {
      return this.$store.state.barriers.type;
    },
    selectedSort() {
      return this.$store.state.barriers.sort;
    },
    per_page() {
      return this.$store.state.barriers.per_page;
    },
    perPages() {
      return this.$store.state.settings.perPages;
    },
    licensed() {
      return this.$store.getters["licensed"];
    },
    sorts() {
      return this.$store.state.settings.sorts;
    },
  },

  methods: {
    setView(view) {
      localStorage.setItem("barriers_view", view);
      this.view = view;
    },
    receiveQuery() {
      if (Object.hasOwnProperty.call(this.$route.query, "perPage")) {
        this.$store.dispatch("barriers/setPerPage", this.$route.query.perPage);
      }
      if (Object.hasOwnProperty.call(this.$route.query, "type")) {
        this.$store.dispatch("barriers/setType", this.$route.query.type);
      }
      if (Object.hasOwnProperty.call(this.$route.query, "sort")) {
        const sort = this.sorts.find((s) => s.id == this.$route.query.sort);
        if (sort) {
          this.$store.dispatch("barriers/setSort", sort);
        }
      }
      if (Object.hasOwnProperty.call(this.$route.query, "page")) {
        this.$store.dispatch("barriers/setPage", this.$route.query.page);
      }
      this.$store.dispatch("barriers/fetch");
    },
    setPage(page) {
      const query = {
        ...this.$route.query,
        page,
      };

      this.$router
        .replace({ path: this.$route.path, query: { ...query } })
        .catch((error) => {});
    },
    setType(type) {
      const query = {
        ...this.$route.query,
        type,
      };

      this.$router
        .replace({ path: this.$route.path, query: { ...query } })
        .catch((error) => {});
    },
    setSort(sort) {
      const query = {
        ...this.$route.query,
        sort,
      };

      this.$router
        .replace({ path: this.$route.path, query: { ...query } })
        .catch((error) => {});
    },
    setPerPage(perPage) {
      const query = {
        ...this.$route.query,
        perPage,
      };

      this.$router
        .replace({ path: this.$route.path, query: { ...query } })
        .catch((error) => {});
    },
    changeCheck(event) {
      this.deletes = [];
      if (event.target.checked) {
        this.$refs.checkDeletes.map((check) => {
          check.checked = true;
          this.deletes.push(check.value);
        });
      } else {
        this.$refs.checkDeletes.map((check) => (check.checked = false));
      }
    },
    copyDeletes() {
      if (!this.deletes.length) {
        alert(this.$t("main.please_select_element"));
        return false;
      }
      this.$store.dispatch("barriers/copy", this.deletes);
      this.deletes = [];
    },
    removeDeletes() {
      this.$store.dispatch("barriers/remove", this.deletes);
      this.deletes = [];
    },
    blockDeletes() {
      this.$store.dispatch("barriers/block", {
        deletes: this.deletes,
        status: 0,
      });
      this.deletes = [];
    },
    unblockDeletes() {
      this.$store.dispatch("barriers/block", {
        deletes: this.deletes,
        status: 1,
      });
      this.deletes = [];
    },
  },
};
</script>
